import { privateApi } from "../../core/http";
export const getWithMenu = async (url, menuId, params) => {
    if (!menuId) {
        throw new Error(`[API] Menu ID is required for request to: ${url}`);
    }
    const api = privateApi();
    const headers = { "X-ID-MENU": menuId };
    const res = await api.get(url, { headers, params });
    return res.data;
};
export const postWithMenu = async (url, data, menuId) => {
    if (!menuId) {
        throw new Error(`[API] Menu ID is required for request to: ${url}`);
    }
    const api = privateApi();
    const headers = { "X-ID-MENU": menuId };
    const res = await api.post(url, data, { headers });
    return res.data;
};
export const putWithMenu = async (url, data, menuId) => {
    if (!menuId) {
        throw new Error(`[API] Menu ID is required for request to: ${url}`);
    }
    const api = privateApi();
    const headers = { "X-ID-MENU": menuId };
    const res = await api.put(url, data, { headers });
    return res.data;
};
export const deleteWithMenu = async (url, menuId) => {
    if (!menuId) {
        throw new Error(`[API] Menu ID is required for request to: ${url}`);
    }
    const api = privateApi();
    const headers = { "X-ID-MENU": menuId };
    const res = await api.delete(url, { headers });
    return res.data;
};
export const downloadFileWithMenu = async (url, menuId, params, fileName) => {
    if (!menuId) {
        throw new Error(`[API] Menu ID is required for request to: ${url}`);
    }
    const api = privateApi();
    const headers = { "X-ID-MENU": menuId };
    const res = await api.get(url, { headers, params, responseType: "blob" });
    // Periksa apakah response merupakan JSON error (meskipun status 200, bisa jadi fallback)
    if (res.data && res.data.type === "application/json") {
        const errorText = await res.data.text();
        let errorJson;
        try {
            errorJson = JSON.parse(errorText);
        }
        catch (e) {
            errorJson = { message: "Gagal memproses dokumen (Format tidak valid)" };
        }
        // Lemparkan error agar ditangkap oleh catch block pemanggil
        throw new Error(errorJson.message || "Gagal memproses dokumen");
    }
    // Extract filename from Content-Disposition header if not provided
    let finalFileName = fileName || "downloaded_file";
    if (!fileName) {
        const disposition = res.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                finalFileName = matches[1].replace(/['"]/g, "");
            }
        }
    }
    const blob = new Blob([res.data]);
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", finalFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
};
/**
 * Fetch file sebagai Blob (dengan auth headers) tanpa memicu download.
 * Digunakan untuk membuka file (misal PDF) di tab baru menggunakan
 * browser viewer bawaan, sambil tetap melewatkan Authorization header.
 */
export const fetchBlobWithMenu = async (url, menuId, params) => {
    if (!menuId) {
        throw new Error(`[API] Menu ID is required for request to: ${url}`);
    }
    const api = privateApi();
    const headers = { "X-ID-MENU": menuId };
    const res = await api.get(url, { headers, params, responseType: "blob" });
    // Periksa apakah response merupakan JSON error
    if (res.data && res.data.type === "application/json") {
        const errorText = await res.data.text();
        let errorJson;
        try {
            errorJson = JSON.parse(errorText);
        }
        catch (e) {
            errorJson = { message: "Gagal memproses dokumen (Format tidak valid)" };
        }
        throw new Error(errorJson.message || "Gagal memproses dokumen");
    }
    return new Blob([res.data], { type: "application/pdf" });
};
